<template>
	<div class="container py-3">
		<EventsSlider />

		<div class="row row-cols-1 row-cols-md-3 g-4 py-3 justify-content-around">
			<div class="col" v-for="(event, index) in events" :key="index">
				<div class="card h-100">
					<img class="card-img-top" :src="event.gridImage" :alt="event.title" @click="goEvent(event.shortId)" />

					<div class="p-1 date_block">
						<div class="text-center">
							<template
								><i class="bi bi-calendar-check"></i>&nbsp;{{ event.dateStart | moment("DD.MM.YYYY") }}</template
							>
							<template v-if="event.dateEnd">
								<template
									v-if="moment(event.dateEnd).format('DD.MM.YYYY') != moment(event.dateStart).format('DD.MM.YYYY')"
								>
									&nbsp;—&nbsp; {{ event.dateEnd | moment("DD.MM.YYYY") }}</template
								>
							</template>
						</div>
					</div>

					<div class="card-body d-flex flex-column justify-content-between">
						<h5 class="card-title py-2">{{ event.title }}</h5>
						<div class="d-flex justify-content-between">
							<button class="btn btn-primary" @click="goEvent(event.shortId)">
								{{ event.actionText ? event.actionText : "Подробнее" }}
							</button>
							<button
								class="btn btn-sm btn-outline-warning ml-1"
								v-if="showAdminBoard || showModeratorBoard"
								@click="editEvent(event._id)"
							>
								Изменить
							</button>
							<button
								class="btn btn-sm btn-outline-info ml-1"
								v-if="showAdminBoard || showModeratorBoard"
								@click="statsEvent(event._id)"
							>
								Статистика
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import EventDataService from "../services/event.service";
import EventsSlider from "../components/EventsSlider";

export default {
	name: "events-list",
	metaInfo: {
		title: "Список событий",
	},
	components: {
		EventsSlider,
	},
	data() {
		return {
			events: [],
		};
	},
	computed: {
		currentUser() {
			return this.$store.state.auth.user;
		},
		showAdminBoard() {
			if (this.currentUser && this.currentUser.roles) {
				return this.currentUser.roles.includes("ROLE_ADMIN");
			}

			return false;
		},
		showModeratorBoard() {
			if (this.currentUser && this.currentUser.roles) {
				return this.currentUser.roles.includes("ROLE_MODERATOR");
			}

			return false;
		},
	},
	methods: {
		retrieveEvents() {
			EventDataService.getPublished()
				.then((response) => {
					this.events = response.data;
				})
				.catch((e) => {
					console.error(e);
				});
		},

		goEvent(id) {
			this.$router.push({ name: "event-details", params: { id: id } });
		},
		editEvent(id) {
			this.$router.push({ name: "event-edit", params: { id: id } });
		},
		statsEvent(id) {
			this.$router.push({ name: "event-stats", params: { id: id } });
		},
	},
	mounted() {
		this.retrieveEvents();
	},
};
</script>

<style scoped>
.card img {
	cursor: pointer;
	--webkit-filter: opacity(75%); /* Chrome, Safari, Opera */
	filter: opacity(75%);
	transition: 0.15s ease-in all;
	transform: scale(1);
}
.card img:hover {
	--webkit-filter: none;
	filter: none;
	transform: scale(1.025);
}
.card .date_block {
	background-color: var(--accent-color);
}
</style>
